var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currency === 'USD')?_c('span',[_vm._v("$")]):(_vm.currency === 'EUR')?_c('span',[_vm._v("€")]):(_vm.currency === 'GBP')?_c('span',[_vm._v("£")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }